import React from "react";
import Sidebar from "../components/sidebar/Sidebar";
import Domain from "../components/domain/Domain";
import { useLocation } from "react-router-dom";

// DomainPage component renders the domain interface with a sidebar and domain content.
// It receives an openDrawer prop to control the sidebar drawer and extracts user data from the location state.
const DomainPage = ({ openDrawer }) => {
  // useLocation hook provides access to the location object, which contains the state passed through navigation.
  const location = useLocation();

  // DomainData object contains settings specific to the domain page, such as UI state.
  const DomainData = {
    isSearchFilterVisible: true, // Boolean flag to control the visibility of search filters
    dashboard: false, // Boolean flag to indicate whether the dashboard view is enabled
  };

  // UserData object extracts user-specific data from the location state for rendering and authentication purposes.
  const UserData = {
    roles: location.state?.roles, // User roles (e.g., admin, user)
    isAdmin: location.state?.isAdmin, // Boolean flag indicating if the user is an admin
    isAuthenticated: location.state?.isAuthenticated, // Boolean flag indicating if the user is authenticated
    refreshToken: location.state?.refreshToken, // Token used to refresh user session
    accessToken: location.state?.accessToken, // Token used for API requests
    userId: location.state?.userId, // Unique identifier for the user
    username: location.state?.username, // Username of the authenticated user
  };

  return (
    <>
      {/* Sidebar component with openDrawer and userData props. 
          The 'active' prop indicates the active menu item in the sidebar (2 in this case). */}
      <Sidebar openDrawer={openDrawer} userData={UserData} active={2} />

      {/* Domain component that renders the main domain content. 
          It receives the openDrawer, userData, and domainData props. */}
      <Domain
        openDrawer={openDrawer}
        userData={UserData}
        domainData={DomainData}
      />
    </>
  );
};

export default DomainPage;
